import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/home/index.tsx';
import { WhyThy } from './pages/why-thy/index.tsx';
// import { Services } from './pages/services/index.tsx';
import { ContactUs } from './pages/contactUs/index.tsx';
import { Products } from './pages/products/index.tsx';
import { LoginPage } from './pages/admin/login/index.tsx';
import { AdminPanel } from './pages/admin/panel/index.tsx';
import { Enquiries } from './pages/admin/enquiries/index.tsx';
import { Reviews } from './pages/admin/reviews/index.tsx';
// import { Portfolio } from './pages/admin/portfolio/index.tsx';
import { ProductsPage } from './pages/admin/products/index.tsx';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about_us" element={<WhyThy />} />
          {/* <Route path="/services" element={<Services />} /> */}
          <Route path="/contact_us" element={<ContactUs />} />
          <Route path="/products" element={<Products />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminPanel />}>
            <Route path="reviews" element={<Reviews />} />
            {/* <Route path="portfolio" element={<Portfolio />} /> */}
            <Route path="products" element={<ProductsPage />} />
            <Route path="enquiries" element={<Enquiries />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;